import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import React, { FC } from 'react';

const GPICreditCardFields: FC = () => (
	<Grid container spacing={2} marginTop={0.5}>
		<Grid item xs={6}>
			<TextField
				required
				name='ccnumber'
				variant='outlined'
				fullWidth
				label='Card Number'
				InputLabelProps={{ shrink: true }}
				InputProps={{
					inputComponent: () => <div style={{ height: '50px' }} id='card-number-gpi' />,
				}}
			/>
		</Grid>
		<Grid item xs={3}>
			<TextField
				required
				name='ccexp'
				variant='outlined'
				fullWidth
				label='Expiration Date'
				InputLabelProps={{ shrink: true }}
				InputProps={{
					inputComponent: () => <div style={{ height: '50px' }} id='card-expiration-gpi' />,
				}}
			/>
		</Grid>
		<Grid item xs={2}>
			<TextField
				required
				name='cvc'
				variant='outlined'
				fullWidth
				label='CVC Code'
				InputLabelProps={{ shrink: true }}
				InputProps={{
					inputComponent: () => <div style={{ height: '50px' }} id='card-cvv-gpi' />,
				}}
			/>
		</Grid>
	</Grid>
);

export default React.memo(GPICreditCardFields);
